import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=395df4ac&scoped=true&"
import script from "./textarea.vue?vue&type=script&lang=js&"
export * from "./textarea.vue?vue&type=script&lang=js&"
import style0 from "./textarea.vue?vue&type=style&index=0&id=395df4ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395df4ac",
  null
  
)

export default component.exports